import { render } from "./regitserCode.vue?vue&type=template&id=3faa50b1"
import script from "./regitserCode.vue?vue&type=script&lang=js"
export * from "./regitserCode.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/hostApply/regitserCode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3faa50b1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3faa50b1', __exports__)) {
    console.log('reload')
    api.reload('3faa50b1', __exports__)
  }
  
  module.hot.accept("./regitserCode.vue?vue&type=template&id=3faa50b1", () => {
    console.log('re-render')
    api.rerender('3faa50b1', render)
  })

}


export default __exports__